import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import 'rxjs';

import { Subject } from "rxjs";



@Injectable()
export class DashboardSubject {

    constructor() { }

    private rescheduled = new Subject<any>();

    setRescheduled(hasrescheduled: any) {
        this.rescheduled.next(hasrescheduled);
    }

    whenRescheduled() {
        return this.rescheduled.asObservable();
    }

}



// WEBPACK FOOTER //
// ./src/app/appointments/dashboard/dashboard-subject.ts